<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{'learning_paths.add_' + type | translate}}</span>
      <button mat-button class="mat-icon-button"
              (click)="dialogRef.close()"
              aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content class="">
        @if (type === 'task') {
          <div class="task-groups">
            @for (group of taskGroups; track group.id) {
              <div class="task-group">
                <mat-checkbox class="task-group-title"
                              [checked]="group.selectedTasks.length === group.tasks.length"
                              [indeterminate]="group.selectedTasks.length > 0 && group.selectedTasks.length < group.tasks.length"
                              (change)="selectGroupTasks(group, $event.checked ? group.tasks : [])">
                  {{ group.title }}
                </mat-checkbox>
                <mat-selection-list [ngModel]="group.selectedTasks"
                                    (ngModelChange)="selectGroupTasks(group, $event)" [attr.aria-label]="group.title">
                  @for (item of group.tasks; track item.id) {
                    <mat-list-option [value]="item">
                      <div class="item">
                        <div class="item-title">{{ item.title }}</div>
                      </div>
                    </mat-list-option>
                  }
                </mat-selection-list>
              </div>
            }
          </div>
        } @else {
        <mat-selection-list class="content-list" [(ngModel)]="selectedItems">
          @for (item of content; track item.id) {
            <mat-list-option [value]="item">
              <div class="item">
                @if (item.picture) {
                  <div class="image" [style.background-image]="'url(' + getImage(item.picture) + ')' "></div>
                }
                <div class="item-title">
                  {{item.title}}
                  @if (this.type === 'event') {
                    ({{item.dateForShow}})
                  }
                </div>
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
        }
      </div>

      <div class="button-wrapper">
        <button mat-raised-button (click)="saveContent()">
          {{'main.save' | translate}}
        </button>
      </div>
</div>
